import React from "react";
import * as styles from "./ScrollToTopButton.module.scss";
import { Icon } from "@silversea-ssc/ui-components-react";
import clsx from "clsx";
import { useLingui } from "@lingui/react/macro";

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}

type Props = { className?: string };
export const ScrollToTopButton: React.FC<React.PropsWithChildren<Props>> = ({
  className
}) => {
  const { t } = useLingui();
  return (
    <button
      onClick={scrollToTop}
      className={clsx(styles.backToTop, className)}
      title={t`Scroll to top`}
    >
      <Icon
        name="arrow-up"
        size="2x"
        padding={false}
        className={styles.backToTopIcon}
      />
    </button>
  );
};
